<template>
  <v-menu offset-y left nudge-bottom="14" min-width="230" content-class="user-profile-menu-content"
    v-if="appbar == true">
    <template v-slot:activator="{ on, attrs }">
      <v-badge bottom color="success" overlap offset-x="12" offset-y="12" class="ms-4" dot>
        <v-avatar size="40px" v-bind="attrs" color="primary" class="v-avatar-light-bg primary--text"
          v-on="on">
          <span class="text-h5">{{email.charAt(0)}}</span>
        </v-avatar>
      </v-badge>

    </template>
    <v-list>
      <div class="pb-3 pt-2">
        <v-badge bottom color="success" overlap offset-x="12" offset-y="12" class="ms-4" dot>
          <v-avatar size="40px" color="primary" class="v-avatar-light-bg primary--text">
            <span class="text-h5">{{email.charAt(0)}}</span>
          </v-avatar>
        </v-badge>
        <div class="d-inline-flex flex-column justify-center ms-3" style="vertical-align:middle">
          <span class="text--primary font-weight-semibold mb-n1">
            @{{email.split('@')[0]}}
          </span>
          <small v-if="isAdmin()" class="text--disabled text-capitalize mt-1 ml-1">Admin</small>
        </div>
      </div>

      <v-divider v-show="false"></v-divider>

      <!-- Profile -->
      <v-list-item href="#" v-show="false">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiAccountOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Profile</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Email -->
      <v-list-item href="#" v-show="false">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiEmailOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Inbox</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Chat -->
      <v-list-item href="#" v-show="false">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiChatOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Chat</v-list-item-title>
        </v-list-item-content>

        <v-list-item-action>
          <v-badge inline color="error" content="2">
          </v-badge>
        </v-list-item-action>
      </v-list-item>

      <v-divider class="my-2" v-show="false"></v-divider>

      <!-- Settings -->
      <v-list-item href="#" v-show="false">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiCogOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Settings</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- Pricing -->
      <v-list-item href="#" v-show="false">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiCurrencyUsd }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Pricing</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- FAQ -->
      <v-list-item href="#" v-show="false">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiHelpCircleOutline }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>FAQ</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="my-2" v-show="false"></v-divider>

      <!-- Logout -->
      <v-list-item @click="logout()">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiLogoutVariant }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { Auth } from 'aws-amplify'

import {
  mdiAccountOutline,
  mdiChatOutline,
  mdiCheckboxMarkedOutline,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiEmailOutline,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
} from '@mdi/js'

export default {
  data() {
    return {
      email: null,
      appbar: false,
      userGroups: [],
    }
  },

  setup() {
    return {
      icons: {
        mdiAccountOutline,
        mdiEmailOutline,
        mdiCheckboxMarkedOutline,
        mdiChatOutline,
        mdiCogOutline,
        mdiCurrencyUsd,
        mdiHelpCircleOutline,
        mdiLogoutVariant,
      },
    }
  },

  computed: {
    User() {
      return this.$store.getters.User
    },
  },

  methods: {
    async logout() {
      try {
        // Clear tokens stored in localStorage or sessionStorage
        localStorage.removeItem('id_token')
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')

        // Clear cookies (if applicable)
        document.cookie = 'id_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
        document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
        document.cookie = 'refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
        await Auth.signOut()
        // Redirect to login page or home page after logging out
        this.$router
          .push({
            name: 'auth-login',
          })
          .catch(() => {})
      } catch (error) {
        console.log('Error signing out: ', error)
      }
    },

    isAdmin() {
      return this.userGroups.includes('Admin') // Check if the user is in the 'Admins' group
    },
  },

  // created() {
  //   if (this.User != null) {
  //     this.appbar = true
  //     this.email = this.User.attributes.email
  //   } else {
  //     this.$router
  //       .push({
  //         name: 'auth-login',
  //       })
  //       .catch(() => {})
  //   }
  // },

  created() {
    // Check if the user is authenticated via AWS Amplify
    Auth.currentAuthenticatedUser()
      .then(user => {
        // console.log('Authenticated User Bar:', user) // Log the entire user object to inspect attributes
        // console.log('User Attributes:', user.attributes)
        if (user) {
          // Set the email to user attributes email or a default email if it doesn't exist
          this.userGroups = user.signInUserSession.accessToken.payload['cognito:groups'] || []
          this.email = 'student@regent.az.za'

          // console.log('User Groups: ', this.userGroups)
          if (user.attributes) {
            this.email = user.attributes.email
          } else {
            this.email = 'student@regent.az.za'
          }
          this.appbar = true
        } else {
          console.log('error here')
          this.$router
            .push({
              name: 'auth-login',
            })
            .catch(() => {})
        }
      })
      .catch(error => {
        console.error('Error fetching user bar:', error)
        this.$router
          .push({
            name: 'auth-login',
          })
          .catch(() => {})
      })
  },
}
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
</style>
